<div class="w-100 h-100" *ngIf="!noData">
    <div class="w-100 h-100" *ngIf="!noDatasetSelected">
        <highcharts-chart *ngIf="chartOptions != null"
            [Highcharts]="highcharts" 
            [options]="chartOptions" 
            (chartInstance)="setChartInstance($event)" 
            class="w-100 d-block h-100"
            ></highcharts-chart>        
    </div>
</div>

<app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
